import {
  initialOrderAggregation,
  OrderAggregationRepository,
  ResultGetForCurrentUser,
} from '@/models/order/aggregation/order-aggregation'
import {
  OrderAggregationSendResult,
  OrderAggregationSendStrategy,
} from '@/models/order/aggregation/send/order-aggregation-send-strategy'
import { Either, left } from 'fp-ts/lib/Either'

/**
 * 注文集計データを外部システムへ送信する
 */
export class OrderAggregationSendService {
  constructor(
    private readonly repository: OrderAggregationRepository,
    private readonly associationStrategy: OrderAggregationSendStrategy
  ) {
  }

  async send(): Promise<Either<Error, void>> {
    const aggregationResult = await this.repository.getForCurrentUser()
      .catch<ResultGetForCurrentUser>(left)
      .then(result => result.map(
        maybe => maybe.getOrElse(initialOrderAggregation)
      ))

    return aggregationResult.fold(
      e => Promise.resolve(left(e)),
      aggregation => this.associationStrategy.send(aggregation).catch<OrderAggregationSendResult>(left)
    )
  }
}
